import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-theme",
  "use": "icon-theme-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-theme\">\r\n  <path d=\"M512 65.4c-327 0-448 285.2-448 445.1 0 159.9 116.3 448 438.5 448 0 0 80.1 1.4 80.1-70.6s-36-49-36-100.8c0-51.9 36-74.9 53.3-74.9 17.3 0 131.1 8.6 194.5-15.9C857.7 671.9 960 594.1 960 461.6c0-116.7-121-396.2-448-396.2zM238.9 512c-43 0-77.8-34.8-77.8-77.8s34.8-77.8 77.8-77.8 77.8 34.8 77.8 77.8c-0.1 43-34.9 77.8-77.8 77.8z m146.7-192.5c-43 0-77.8-34.8-77.8-77.8s34.8-77.8 77.8-77.8c42.9 0 77.8 34.8 77.8 77.8s-34.8 77.8-77.8 77.8z m249.5 0c-42.9 0-77.8-34.8-77.8-77.8s34.8-77.8 77.8-77.8c42.9 0 77.8 34.8 77.8 77.8s-34.8 77.8-77.8 77.8zM783.2 512c-42.9 0-77.8-34.8-77.8-77.8s34.8-77.8 77.8-77.8 77.8 34.8 77.8 77.8c0.1 43-34.8 77.8-77.8 77.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/theme.svg
// module id = hdtf
// module chunks = 54